/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function() {

      if(document.querySelector('.conditional-join')){
        document.querySelector('.conditional-join').style.display = 'none';
      }

      if(document.querySelector('select[name="user-engagement"]')){
        document.querySelector('select[name="user-engagement"]').addEventListener('change', function(e) {
          //check if value is 1
          if(e.target.value === 'Join the team') {
            //show the div
            document.querySelector('.conditional-join').style.display = 'block';
          } else {
            //hide the div
            document.querySelector('.conditional-join').style.display = 'none';
          }
        })
      }

      if($('.readmore')){
        $('.readmore').each(function(){
          var parent = $(this).parents(".wp-block-uagb-buttons");
          console.log(parent);
          parent.addClass('readmore-dropdown');
        })
    
        $('.readmore').on('click', function(e) {
          e.preventDefault();
          var parent = $(this).parents(".wp-block-uagb-buttons");
          
          parent.toggleClass('readmore-dropdown--active');
          
        })
      }

      if($('.banner .burger')){
        $('.banner .burger').on('click', function(){
          $('.menu-mobile').toggleClass('active')
        })
      }
      

      if($('.menu-mobile__overlay, .menu-mobile a, .menu-mobile .close')){
        $('.menu-mobile__overlay, .menu-mobile a, .menu-mobile .close').on('click', function(){
          $('.menu-mobile').removeClass('active')
        })
      }
    })
   

    var lastScrollTop = 0;

    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    document.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > lastScrollTop) {
          // downscroll code
          $('header.banner').addClass('hide')
          $('header.banner').removeClass('show')

      } else if (st < lastScrollTop) {
          // upscroll code
          $('header.banner').removeClass('hide')

          $('header.banner').addClass('show')
      } // else was horizontal scroll
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js